import { render, staticRenderFns } from "./documentInfo.vue?vue&type=template&id=16ba7d2a&scoped=true&"
import script from "./documentInfo.vue?vue&type=script&lang=js&"
export * from "./documentInfo.vue?vue&type=script&lang=js&"
import style0 from "./documentInfo.vue?vue&type=style&index=0&id=16ba7d2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba7d2a",
  null
  
)

export default component.exports